const wizzyIsMobile = window.screen.width < 768;
window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT, //PRODUCTS_RESULTS_RENDERED
    function (payload) {
      payload.store.currency.symbol = "Rs. ";
      payload.common.lazyDOMConfig.searchInputIdentifiers = [];
      if (window.innerWidth >= 768) {
        payload.common.lazyDOMConfig.searchInputIdentifiers.push({
          dom: "#header-search input", // #inputID or .InputClass
          type: "text", // Type of Input Search or Text
        });
      } else {
        payload.common.lazyDOMConfig.searchInputIdentifiers.push({
          dom: ".wizzy-mobile-search-input", // #inputID or .InputClass
          type: "search", // Type of Input Search or Text
        });
      }
      payload.common.lazyDOMConfig.contentDOMIdentifiers.push("#content");

      payload["search"]["configs"]["pagination"]["infiniteScrollOffset"] = {
        desktop: 1000,
        mobile: 2000,
      };
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      $("#wizzy-search-input").removeClass("display-block");
      return payload;
    }
  );

  //    window.wizzyConfig.events.registerEvent(
  //     window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
  //     function (payload) {

  //       if(payload.api === 'search' || payload.api === "filter"){
  //     var facets = payload.response.payload.facets;
  // console.log('======>here<=====')
  //     facets.forEach((facet)=>{
  //       if(facet.key === 'colors'){
  //          const facetItem = facet.data;
  //           console.log(facetItem,'====>facetItem');
  //         facetItem.forEach((item)=>{
  //           console.log('====>start')
  //           item.isSwatch = true;
  //           item.isURLSwatch = true;
  //           item.isVisualSwatch =true;

  //           let color=item.key;
  //           color=color.replace(' and ','-');
  //             color=color.replace(' & ','-');
  //             color=color.replace('/','-');
  //             color=color.toLowerCase();
  //             item.color=color;
  //             item.swatchValue = '//cdn.shopify.com/s/files/1/0068/0214/5380/files/'+color+'.png';

  //           item.data = {value: item.swatchValue, swatch: {type: 'visual', value: item.swatchValue}}
  //         })
  //       }
  //     })

  //   }
  //       console.log('====>end')

  //       // console.log(payload, '<<========payload');
  //       // let filters=payload.response.payload.facets;
  //       // let colors=filters[4].data;

  //       // colors.forEach((product)=>{
  //       //   let color=product.key;
  //       //   color=color.replace(' and ','-');
  //       //   color=color.replace(' & ','-');
  //       //   color=color.replace('/','-');
  //       //   color=color.toLowerCase();
  //       //   //console.log(color);
  //       //   product.data=
  //       //     {
  //       //       swatch:{
  //       //         type:'visual',
  //       //         value:'red'
  //       //       }
  //       //     };

  //       //   product.isSwatch=true;
  //       //   product['isVisualSwatch']=true;
  //       //   proudct.isURLSwatch=false;
  //       //   product.swatchValue=color;
  //       //   product['test'] = "SHrey";
  //       //   product.url='//cdn.shopify.com/s/files/1/0068/0214/5380/files/'+color+'.png';
  //       //   product.cu
  //       //   //$(".mycolor").css({"background-color":color});
  //       // });

  //       console.log(payload,"<<==================colors");
  //       return payload;
  //     }
  //   );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      $("body #content").addClass("row");
      $(".wizzy-search-back .wizzy-icon").click();
      $("body").removeClass("wizzy-mobile-scroll-fix");
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((product) => {
        product.isNew = false;
        let categories = product.categories;
        categories.forEach((category) => {
          if (category.name === "NEW ARRIVALS") {
            product.isNew = true;
          }
        });
      });
      // console.log(prod,"jnjndjnwenfiwjfijwefhihiwehfwijfknfwkmcwekfmfwopkv j fokf");
      // console.log(payload, "<+++++++++++++++++++++++++++++++Modified Payload")
      return payload;
    }
  );

  // replaceTemplate("wizzy-search-results-product");
  // replaceTemplate("wizzy-autocomplete-topproducts");
  wizzyMobilePopup();
  // wizzyAutocomplete();
  WizzyAddToSearch();
  // WizzyAutoComple1();

  // WizzyProductPath();
};

// function  WizzyProductPath()
// {
//   // if ($(".wizzy-search-results-rendered.shifter-page is-moved-by-drawer.row#breadcrumb").hasClass("isStuck"))
//   if ($("body .wizzy-search-results-rendered .row").hasClass(".desktop-12") )
//   {
//     $("#breadcrumb").css({"display":"none"});
//     console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrrrr");
//   }
// }
function WizzyAutoComplete1() {
  // $('body').attr('id', 'parasnewID');
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutationRecord) {
      // alert("style changed!");

      if ($(mutationRecord.target).hasClass("isStuck")) {
        $("body").addClass("my-auto-setting");
      } else {
        $("body").removeClass("my-auto-setting");
      }
    });
  });

  var target = document.getElementById("parasNew");
  observer.observe(target, { attributes: true, attributeFilter: ["class"] });
}

function wizzyMobilePopup() {
  $(".wizzy-search-icon").click(function () {
    $("#wizzy-search-input").addClass("display-block");
    $("body").addClass("wizzy-mobile-scroll-fix");
    $(".wizzy-search-modal-input input").click();
  });

  $("body").on("click", ".wizzy-search-back", function () {
    if (window.innerWidth < 768) {
      $("body").removeClass("wizzy-mobile-scroll-fix");
    }
  });
}

function wizzyAutocomplete() {
  $("body").addClass("auto-fix-setting");
  $(window).scroll(function () {
    // console.log("nsjwncjncncjancjcnascn");
    if ($(".header-wrapper.stuckMenu").hasClass("isStuck")) {
      $(".wizzy-autocomplete-wrapper.onLeft").addClass("auto-setting");
    } else {
      $(".wizzy-autocomplete-wrapper.onLeft").removeClass("auto-setting");
    }
  });
}

function WizzyAddToSearch() {
  $(document).ready(function () {
    WizzyAutoComplete1();

    // $("body #content").addClass("row");

    if (window.innerWidth < 768) {
      $("body").on("click", ".autocomplete-text-wrapper", function (e) {
        // console.log("2hbjfnjvnufiji ejnifeoimwokcmwcmwmopec ekfopecwoepcpwoc  okdowekdowekdwopkdopkd");

        var query = $(this).parent().attr("data-searchterm");
        console.log(query);
        $("#wizzy-search-input").val(query);

        // console.log("3hbjfnjvnufiji ejnifeoimwokcmwcmwmopec ekfopecwoepcpwoc  okdowekdowekdwopkdopkd");
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      });
    }
  });
}
